import React from "react";
import { TbAlertTriangle, TbPencil } from "react-icons/tb";
import {
  Box,
  Chip,
  Col,
  FabButton,
  Flex,
  Row,
  Typography,
} from "../../../ppui";
import { Icon } from "../../../ppui/icon";
import { logger } from "../../../utils/logger";
import { AllowanceBox } from "../../style";

const DepartmentList = ({ resource, handleAddNewClickOpen }) => {
  if (!resource) {
    throw new Promise(() => {});
  }
  const bankRes = resource.read();

  return (
    <>
      {bankRes?.data?.data?.departments.length > 0 ? (
        <Flex gap={20} direction={"column"}>
          {bankRes?.data?.data?.departments?.map((it, ind) => (
            <AllowanceBox key={it?.id || ind}>
              <Row alignItems="center" gap={{ md: 20, lg: 30, xxl: 60 }}>
                <Col md={3} xl={2}>
                  <Box>
                    <Box className="label">Sl. No</Box>
                    <Box className="value">{ind + 1}</Box>
                  </Box>
                </Col>

                <Col md={5} xl={4}>
                <Box>
                      <Box className="label"> Department Name</Box>
                      <Box className="value">{it?.deptName}</Box>
                    </Box>
                </Col>

                <Col>
                
                <Box>
                      <Box className="label"> Status</Box>
                      <Box className="value">
                        <Chip
                          color={it?.status ? "success" : "danger"}
                          label={it?.status ? "Open" : "Close"}
                          onClick={() => {
                            logger.log(it, "click here");
                            handleAddNewClickOpen(it);
                          }}
                          size="sm"
                          dot
                        />
                      </Box>
                    </Box>


                </Col>

                <Col sm={"auto"}>
                  <FabButton
                    icon={<TbPencil />}
                    shape="box"
                    size="sm"
                    variant="filled"
                    onClick={() => handleAddNewClickOpen(it)}
                  />
                </Col>
              </Row>
            </AllowanceBox>
          ))}
        </Flex>
      ) : (
        <AllowanceBox>
          <Icon color={"denger"} size={"lg"}>
            <TbAlertTriangle />
          </Icon>
          <Typography
            variant="body1"
            display="flex"
            gap={10}
            alignItem="center"
            mb={"0"}
            p={15}
          >
            No predefined department available.
          </Typography>
        </AllowanceBox>
      )}
    </>
  );
};

export default DepartmentList;
